import { BaseComponent } from "../../Library/BaseComponent";
import { OnInit, Component, Input } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';
import { AnswerOption } from "../../Models/RequestModels";
import { AnswerTypes } from "../../Models/EnumModels";

@Component({
    selector: 'QuestionResponseView',
    templateUrl: './QuestionResponseView.html'
})
export class QuestionResponseView extends BaseComponent implements OnInit {

    @Input() Model?: AnswerOption

    answerTypes = AnswerTypes;
    
    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService) {

        super(translate, toastr, route, router, masterService);
    }

    ngOnInit() { }

}
